var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0731 16.5L18.1922 16.5M18.1922 16.5H14.8078M18.1922 16.5C16.5 16.5 16.4559 17.6281 16.5 18.1922M18.1922 16.5C16.5 16.5 16.5475 15.3665 16.5 14.8078M16.5 14.8078V6.92686M16.5 14.8078V18.1922M16.5 14.8078C16.5 16.5 15.3719 16.5174 14.8078 16.5M16.5 26.0731V18.1922M6.92686 16.5L14.8078 16.5M14.8078 16.5C15.3719 16.4719 16.5 16.5 16.5 18.1922",
    stroke: "white",
    strokeWidth: 1.70213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.5feddb1725497fb96001d1d082ef9795.svg";
export { ForwardRef as ReactComponent };